<template>
  <div>
    <mainVue>
      <template v-slot:main="main">
        <authorVue :data-list="main.data"></authorVue>
      </template>
    </mainVue>
  </div>
</template>

<script>
  import mainVue from '../../../components/resource/main.vue'
  import authorVue from '../../../components/resource/author.vue';

  export default {
    name: 'PortalInBooks',
    components: {
      authorVue, mainVue
    },
    data() {
      return {};
    },

    mounted() {
    },

    methods: {},
  };
</script>

<style lang="less" scoped>

</style>
